"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localeReducer = void 0;

var _actions = require("../base/actions");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @description
 * Returns a default state for the reducer.
 *
 */
var getDefaultState = function getDefaultState() {
  return {
    language: _constants.DEFAULT_LANGUAGE,
    languageOrder: [],
    languageCultureMap: {
      en: 'en-150',
      de: 'de',
      es: 'es',
      ko: 'ko',
      ru: 'ru',
      zh_CN: 'zh'
    },
    messages: {},
    culture: _constants.DEFAULT_CULTURE,
    cultureOrder: []
  };
};
/**
 * @desc Handles all actions related to locales.
 * @param state
 * @param action
 * @returns {*}
 */


var localeReducer = function localeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type;

  var _ref = action.payload || {},
      culture = _ref.culture,
      language = _ref.language,
      messages = _ref.messages,
      cultureOrder = _ref.cultureOrder,
      languageOrder = _ref.languageOrder,
      languageCultureMap = _ref.languageCultureMap;

  switch (type) {
    case _actions.SET_LANGUAGE:
      {
        // Set the language as the default language if the language can't be found in the list of languages
        return _objectSpread(_objectSpread({}, state), {}, {
          language: state.messages[language] ? language : _constants.DEFAULT_LANGUAGE
        });
      }

    case _actions.SET_LANGUAGE_ORDER:
      return _objectSpread(_objectSpread({}, state), {}, {
        languageOrder: languageOrder
      });

    case _actions.REGISTER_LANGUAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        messages: _objectSpread(_objectSpread({}, state.messages), {}, _defineProperty({}, language, messages))
      });

    case _actions.SET_CULTURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        culture: culture || _constants.DEFAULT_CULTURE
      });

    case _actions.SET_CULTURE_ORDER:
      return _objectSpread(_objectSpread({}, state), {}, {
        cultureOrder: cultureOrder
      });

    case _actions.SET_LANGUAGE_CULTURE_MAP:
      return _objectSpread(_objectSpread({}, state), {}, {
        languageCultureMap: languageCultureMap
      });

    default:
      return state;
  }
};

exports.localeReducer = localeReducer;
//# sourceMappingURL=reducers.js.map